import { ref } from 'vue';
import { defineStore } from 'pinia';
import { applyPatch } from 'fast-json-patch';

export const useAdminEventActivityStore = defineStore('adminEventActivityStore', () => {
    const events = ref({});

    function addEventActivity(eventActivityModel) {
        events.value[eventActivityModel.id] = eventActivityModel;
    }

    function updateEventActivity(id, eventActivityModel) {
        events.value[id] = eventActivityModel;
    }

    function removeEventActivity(id) {
        delete events.value[id];
    }

    function applyJsonPatch(id, jsonPatch) {
        applyPatch(events.value[id], jsonPatch, false, true);
    }

    return {
        events,
        addEventActivity,
        updateEventActivity,
        removeEventActivity,
        applyJsonPatch
    }
})